import baseCreate from "./_baseCreate.js";
import extendOwn from "./extendOwn.js";
export default function create(prototype, props) {
  var result = baseCreate(prototype);
  if (props) extendOwn(result, props);
  return result;
}
